import React, { useState, useEffect } from "react";

interface Log {
  db_name: string;
  provided_name: string;
  record_id: string;
  reason: string;
  timestamp: string;
  confidence: string;
}

function MainComponent() {
  const [result, setResult] = useState<any>(null);
  const [logs, setLogs] = useState<Log[]>([]);
  const [name, setName] = useState<string>("");
  const [id, setId] = useState<string>("");
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const [reason, setReason] = useState<string>("");
  const [action, setAction] = useState<string>("");
  const [rules, setRules] = useState<any[]>([]);
  const [showRulesPopup, setShowRulesPopup] = useState<boolean>(false);
  const [users, setUsers] = useState<any[]>([]);
  const [showUsersPopup, setShowUsersPopup] = useState<boolean>(false);
  const [showAddUserForm, setShowAddUserForm] = useState<boolean>(false);
  const [newIban, setNewIban] = useState<string>("");
  const [newName, setNewName] = useState<string>("");
  const [newRule, setNewRule] = useState<string>("");

  const [showSettingsPopup, setShowSettingsPopup] = useState<boolean>(false);
  const [useLevenshtein, setUseLevenshtein] = useState<boolean>(false);
  const [threshold, setThreshold] = useState<number>(1);

  const fetchLogs = async () => {
    const response = await fetch(
      "https://mutual-gelding-openly.ngrok-free.app/logs"
    );
    const data: Log[] = await response.json();
    setLogs(data);
  };

  const fetchRules = async () => {
    const response = await fetch(
      "https://mutual-gelding-openly.ngrok-free.app/rules"
    );
    const data = await response.json();
    setRules(data);
  };

  const handleDeleteRule = async (ruleId: string) => {
    await fetch(
      `https://mutual-gelding-openly.ngrok-free.app/rules/${ruleId}`,
      {
        method: "DELETE",
      }
    );
    fetchRules();
  };

  const handleShowRules = async () => {
    await fetchRules();
    setShowRulesPopup(true);
  };

  useEffect(() => {
    fetchLogs();
  }, []);

  const refreshLogs = () => {
    fetchLogs();
  };

  const handleSubmit = async () => {
    const response = await fetch(
      "https://mutual-gelding-openly.ngrok-free.app/check-name",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name,
          id,
          threshold,
          levenshtein: useLevenshtein ? 1 : 0,
        }),
      }
    );
    const data = await response.json();
    setResult(data);

    if (data.require_human) {
      setShowPopup(true);
    }
    setName("");
    setId("");
    refreshLogs();
  };

  console.log(result);

  const handleApprove = async () => {
    const response = await fetch(
      "https://mutual-gelding-openly.ngrok-free.app/human-intervention",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ action, reason }),
      }
    );
    const result = await response.json();
    setShowPopup(false);
    setReason("");
    setAction("");
    setResult(null);
    console.log(result);
  };

  const fetchUsers = async () => {
    const response = await fetch(
      "https://mutual-gelding-openly.ngrok-free.app/get_name"
    );
    const data = await response.json();
    setUsers(data);
  };

  const handleDeleteUser = async (userId: string) => {
    await fetch(
      `https://mutual-gelding-openly.ngrok-free.app/delete_name/${userId}`,
      {
        method: "DELETE",
      }
    );
    fetchUsers();
  };

  const handleShowUsers = async () => {
    await fetchUsers();
    setShowUsersPopup(true);
  };

  const handleAddUser = async () => {
    await fetch("https://mutual-gelding-openly.ngrok-free.app/add_name", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ iban: newIban, name: newName }),
    });
    setNewIban("");
    setNewName("");
    fetchUsers();
    setShowAddUserForm(false);
  };

  const handleAddRule = async () => {
    await fetch("https://mutual-gelding-openly.ngrok-free.app/rules", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ rule: newRule }),
    });
    setNewRule("");
    fetchRules();
  };

  console.log(users, "Users");

  return (
    <section className="pt-3 px-3">
      <div className=" flex justify-end">
        <button
          className="p-3 bg-yellow-500 text-white rounded-md hover:bg-yellow-600 transition duration-200 mr-2"
          onClick={handleShowRules}
        >
          Rules
        </button>
        <button
          className="p-3 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition duration-200 mr-2"
          onClick={handleShowUsers}
        >
          Users
        </button>
        <button
          className="p-3 bg-purple-500 text-white rounded-md hover:bg-purple-600 transition duration-200"
          onClick={() => setShowSettingsPopup(true)}
        >
          Settings
        </button>
      </div>
      <div className="flex flex-row gap-5 items-center p-6 bg-gray-100 rounded-lg shadow-md mx-auto">
        <div className=" w-full flex flex-col">
          <h1 className="text-2xl font-bold mb-4">Name Checker</h1>
          <p className="mb-4">
            Enter a record ID and name to check similarity with database entry
          </p>
          <div className="flex flex-col gap-3 w-full">
            <input
              className="w-full p-3 border border-gray-300 rounded-md text-lg"
              value={id}
              onChange={(e) => setId(e.target.value)}
              placeholder="IBAN"
              required
            />
            <input
              className="w-full p-3 border border-gray-300 rounded-md text-lg"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Name"
              required
            />
            {/* <div className="mb-4 w-full">
              <label className="block text-lg mb-2">
                Similarity Threshold: {threshold}
              </label>
              <input
                type="range"
                min="0"
                max="100"
                value={threshold}
                onChange={(e) => setThreshold(Number(e.target.value))}
                className="w-full"
              />
            </div> */}
            <button
              className={`w-full p-3 rounded-md transition duration-200 ${
                id && name
                  ? "bg-blue-500 text-white hover:bg-blue-600"
                  : "bg-gray-300 text-gray-500 cursor-not-allowed"
              }`}
              onClick={handleSubmit}
              disabled={!id || !name}
            >
              Check Name
            </button>
          </div>
          {result && (
            <div className="mt-4 p-3 border border-blue-500 rounded-md bg-blue-100 text-blue-700 w-full">
              <h2 className="font-semibold">Result:</h2>
              <p>Record ID: {result?.record_id}</p>
              <p>Provided Name: {result?.provided_name}</p>
              <p>Confidence: {result?.confidence}</p>
              {/* <p>Similarity Score: {result?.similarity_score}</p> */}
              {result?.reason && <p>Reason: {result?.reason}</p>}
              {result?.reject === true ? (
                <p className="text-red-600">Rejected</p>
              ) : result?.require_human ? (
                <div className=" flex flex-row justify-between items-center">
                  <p className="text-red-600">
                    ⚠️ Human review required! Please verify if these names
                    match.
                  </p>
                  <div>
                    <button
                      onClick={() => setShowPopup(true)}
                      className="w-full p-3 bg-green-500 text-white rounded-md hover:bg-green-600 transition duration-200"
                    >
                      Verify
                    </button>
                  </div>
                </div>
              ) : (
                <p className="text-green-600">✅ Automatic match confirmed.</p>
              )}
            </div>
          )}
        </div>

        {
          <div className="mt-6 w-full ">
            <div className=" flex flex-row justify-between items-center py-3">
              <h2 className="text-lg font-semibold mb-2">Logs:</h2>
              <div>
                <button
                  className="w-full p-3 bg-green-500 text-white rounded-md hover:bg-green-600 transition duration-200"
                  onClick={refreshLogs}
                >
                  Refresh Logs
                </button>
              </div>
            </div>
            <div className="h-[400px] overflow-y-scroll">
              <div className="w-full overflow-x-auto">
                <table className="w-full bg-white border border-gray-300 rounded-md shadow ">
                  <thead>
                    <tr>
                      <th className="p-3 border-b">Record ID</th>
                      <th className="p-3 border-b">Provided Name</th>
                      <th className="p-3 border-b">DB Name</th>
                      <th className="p-3 border-b">Confidence</th>
                      <th className="p-3 border-b">Timestamp</th>
                      <th className="p-3 border-b">Reason</th>
                    </tr>
                  </thead>
                  <tbody>
                    {logs.map((log, index) => (
                      <tr
                        key={index}
                        className="hover:bg-gray-100 transition duration-200"
                      >
                        <td className="p-3 border-b">{log?.record_id}</td>
                        <td className="p-3 border-b">{log?.provided_name}</td>
                        <td className="p-3 border-b">{log?.db_name}</td>
                        <td className="p-3 border-b">{log?.confidence}</td>
                        <td className="p-3 border-b">{log?.timestamp}</td>
                        <td className="p-3 border-b w-[500px]">
                          <div className="w-[500px] overflow-x-auto">
                            {log?.reason}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        }

        {showPopup && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white p-6 rounded-md shadow-md w-[400px]">
              <div className=" flex flex-row justify-between">
                <h2 className="text-lg font-semibold">
                  Human Verification Required
                </h2>
                <button onClick={() => setShowPopup(false)}>Close</button>
              </div>
              <div className="mt-4">
                <label className="block text-lg mb-2">Select Action:</label>
                <select
                  value={action}
                  onChange={(e) => setAction(e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded-md"
                >
                  <option value="">-- Select Action --</option>
                  <option value="accept">Accept</option>
                  <option value="reject">Reject</option>
                </select>
              </div>
              {action === "accept" && (
                <div className="mt-4">
                  <label className="block text-lg mb-2">Reason:</label>
                  <input
                    type="text"
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    className="w-full p-2 border border-gray-300 rounded-md"
                    placeholder="Enter reason for approval"
                  />
                </div>
              )}
              <button
                className="mt-2 p-2 bg-blue-500 text-white rounded-md"
                onClick={handleApprove}
              >
                Submit Reason
              </button>
            </div>
          </div>
        )}

        {showSettingsPopup && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white p-6 rounded-md shadow-md w-[400px]">
              <div className="flex flex-row justify-between">
                <h2 className="text-lg font-semibold">Settings</h2>
                <button onClick={() => setShowSettingsPopup(false)}>
                  Close
                </button>
              </div>
              <div className="mt-4">
                <div className="flex items-center mb-4">
                  <label className="flex items-center cursor-pointer">
                    <div className="relative">
                      <input
                        type="checkbox"
                        className="sr-only"
                        checked={useLevenshtein}
                        onChange={(e) => setUseLevenshtein(e.target.checked)}
                      />
                      <div
                        className={`block w-14 h-8 rounded-full ${
                          useLevenshtein ? "bg-green-500" : "bg-gray-300"
                        }`}
                      ></div>
                      <div
                        className={`dot absolute left-1 top-1 bg-white w-6 h-6 rounded-full transition transform ${
                          useLevenshtein ? "translate-x-6" : ""
                        }`}
                      ></div>
                    </div>
                    <div className="ml-3 text-gray-700 font-medium">
                      Use Levenshtein Distance
                    </div>
                  </label>
                </div>
                <div className="mb-4">
                  <label className="block text-lg mb-2">
                    Similarity Threshold: {threshold}
                  </label>
                  <input
                    type="range"
                    min="1"
                    max="100"
                    value={threshold}
                    onChange={(e) => setThreshold(Number(e.target.value))}
                    className="w-full"
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        {showRulesPopup && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white p-6 rounded-md shadow-md">
              <div className="flex flex-row justify-between">
                <h2 className="text-lg font-semibold">Rules</h2>
                <button onClick={() => setShowRulesPopup(false)}>Close</button>
              </div>
              <ul className="mt-4 space-y-2">
                {rules.map((rule) => (
                  <li
                    key={rule.id}
                    className="flex justify-between items-center p-3 bg-gray-100 rounded-md shadow hover:bg-gray-200 transition duration-200"
                  >
                    <span className="text-lg font-medium">{rule.rule}</span>
                    <button
                      onClick={() => handleDeleteRule(rule.id)}
                      className="text-red-500 hover:text-red-700 transition duration-200 ml-4"
                    >
                      Delete
                    </button>
                  </li>
                ))}
              </ul>
              <div className="mt-4">
                <input
                  type="text"
                  value={newRule}
                  onChange={(e) => setNewRule(e.target.value)}
                  placeholder="Enter new rule"
                  className="w-full p-2 border border-gray-300 rounded-md mb-2"
                />
                <button
                  className="w-full p-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition duration-200"
                  onClick={handleAddRule}
                >
                  Add Rule
                </button>
              </div>
            </div>
          </div>
        )}

        {showUsersPopup && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white p-6 rounded-md shadow-md">
              <div className="flex flex-row justify-between">
                <h2 className="text-lg font-semibold">Users</h2>
                <button onClick={() => setShowUsersPopup(false)}>Close</button>
              </div>
              <button
                className="my-4 p-2 bg-green-500 text-white rounded-md hover:bg-green-600 transition duration-200"
                onClick={() => setShowAddUserForm((prev) => !prev)}
              >
                Add User
              </button>
              {showAddUserForm && (
                <div className="mt-4">
                  <input
                    type="text"
                    value={newIban}
                    onChange={(e) => setNewIban(e.target.value)}
                    placeholder="IBAN"
                    className="w-full p-2 border border-gray-300 rounded-md mb-2"
                  />
                  <input
                    type="text"
                    value={newName}
                    onChange={(e) => setNewName(e.target.value)}
                    placeholder="Name"
                    className="w-full p-2 border border-gray-300 rounded-md mb-2"
                  />
                  <button
                    className="w-full p-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition duration-200 my-2"
                    onClick={handleAddUser}
                  >
                    Submit
                  </button>
                </div>
              )}
              <div className="h-64 overflow-y-auto">
                <table className="w-full bg-white border border-gray-300 rounded-md shadow">
                  <thead>
                    <tr>
                      <th className="p-3 border-b">IBAN</th>
                      <th className="p-3 border-b">Name</th>
                      <th className="p-3 border-b">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {users.map((user) => (
                      <tr
                        key={user.id}
                        className="hover:bg-gray-100 transition duration-200"
                      >
                        <td className="p-3 border-b">{user.IBAN}</td>
                        <td className="p-3 border-b overflow-hidden text-center">
                          <div className="whitespace-nowrap overflow-ellipsis overflow-hidden max-w-xs">
                            {user.Name}
                          </div>
                        </td>
                        <td className="p-3 border-b">
                          <button
                            onClick={() => handleDeleteUser(user.IBAN)}
                            className="text-red-500 hover:text-red-700 transition duration-200"
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

export default MainComponent;
